import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';

import { TableHashDataProvider } from '../../../hooks/useTableHashData';
import { HubLayoutContext, createLayoutState } from '../../../hooks/useHubLayout';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';

function Layout({ children }) {
  const layoutData = createLayoutState();

  return (
    <TableHashDataProvider>
      <HubLayoutContext.Provider value={layoutData}>
        <section className="d-flex flex-column svh-100 ">
          {layoutData.headerVisible && <Header />}
          <Content>
            <Container as="main" className="px-0 flex-grow-1">{children}</Container>
            {layoutData.footerComponent && <Footer />}
          </Content>
        </section>
      </HubLayoutContext.Provider>
    </TableHashDataProvider>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Layout;
